import { useUserData } from "@/composables/userData";
import { customAxios } from "@/service/customAxios";
import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: JSON.parse(localStorage.getItem("essecheck_user"))
  }),
  getters: {
    roles(state) {
      if (!state.user) {
        return [];
      }

      const dict = {
        ROLE_ADMIN: "Админ",
      };

      const roles = [];

      state.user.roles.forEach((v) => {
        if (v.toUpperCase().includes("USER")) {
          return;
        } else if (dict[v] !== undefined) {
          roles.push({
            title: dict[v],
            value: v,
          });
        }
      });

      return roles;
    },
    userId(state) {
      if (!state.user) {
        return null;
      }
      return state.user.id;
    },

     haveAdmin() {
      if (!this.user) {
        return false;
      }

      return this.user.roles.includes("ROLE_ADMIN");
    },
    isAdmin() {
      if (!this.user) {
        return false;
      }

      return this.mainRole === "ROLE_ADMIN";
    },

  },
  actions: {

    logout() {
      const { resetUserLocalStorage } = useUserData();

      customAxios.setUser(null);
      this.reset();
      resetUserLocalStorage();
    },
    reset() {
      this.user = null;
      this.mainRole = null;
      this.profile = null;
    },
    setUser(data) {
      this.user = data;
      console.log("user in set user: " + this.user);
      localStorage.setItem("essecheck_user", JSON.stringify(this.user));
      customAxios.setUser(data);
    },
    setProfile(data) {
      this.profile = data;
      localStorage.setItem("user-profile", JSON.stringify(this.profile));
    },
    setNewTokens(newAccessToken, newRefreshToken) {
      this.user.token = newAccessToken;
      this.user.refreshToken = newRefreshToken;
    },
  },
});
